module.exports = require("@bechtel/client-assets/dist/images/empty-weld-detail.svg");